const PARTNER_CODE_STORAGE_KEY = "mango_partner_code";

function capturePartnerCode() {
    if (typeof window === "undefined") {
        return;
    }

    try {
        const partnerCode = new URLSearchParams(window.location.search).get("ref");

        if (partnerCode) {
            window.sessionStorage.setItem(PARTNER_CODE_STORAGE_KEY, partnerCode);
        }
    } catch (error) {
        // sessionStorage indisponível (modo privado, navegador antigo etc.)
    }
}

function getPartnerCode() {
    if (typeof window === "undefined") {
        return "";
    }

    try {
        const fromUrl = new URLSearchParams(window.location.search).get("ref");

        if (fromUrl) {
            return fromUrl;
        }

        return window.sessionStorage.getItem(PARTNER_CODE_STORAGE_KEY) || "";
    } catch (error) {
        return "";
    }
}

export { capturePartnerCode, getPartnerCode };
